import {createApp} from "vue";
import pageContainer from './components/lostPass.vue';

document.addEventListener(
    "DOMContentLoaded",
    () => {
        createApp(pageContainer)
            .mount("#modify-lost-pass");
    });